export const VALIDATION_ERROR_MESSAGE = {
  plan: {
    require: 'プランを選択してください。',
  },

  num_of_members: {
    require: '想定利用人数を選択してください。',
  },

  name: {
    require: 'お名前は必須項目です。',
  },

  nameKana: {
    require: 'フリガナは必須項目です。',
  },

  organization: {
    require: '会社名は必須項目です。',
  },

  section: {
    require: '担当部署を選択してください。',
  },

  position: {
    require: '役職を選択してください。',
  },

  tel: {
    require: '電話番号は必須項目です。',
    validate: '電話番号が正しく入力されていません。',
  },

  email: {
    require: 'メールアドレスは必須項目です。',
    validate: '有効なメールアドレスを入力してください。',
  },

  category: {
    require: '種別を選択してください。',
  },

  agree_flag: {
    require: 'プライバシーポリシー・利用規約に同意してください。',
  },
};
